import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class RollsRowCell extends PureComponent {
  static propTypes = {
    onRollsClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    header: PropTypes.string,
    value: PropTypes.string
  };

  static defaultProps = {
    className: "",
    header: "",
    value: ""
  };

  render() {
    return (
      <div role="cell" className={classNames("sorted-list__data", this.props.className)}>
        {this.props.header && <span className="sorted-list__data-header">{this.props.header}</span>}
        <button onClick={this.props.onRollsClick} className="bills__rolls-link">
          {this.props.value}
        </button>
      </div>
    );
  }
}

export default RollsRowCell;



// WEBPACK FOOTER //
// ./src/components/BillOfLading/List/Products/RollsRowCell.js